const q = require('queried');
const on = require('emmy/on');
const emit = require('emmy/emit');

function multipleTitleIsShown(containers) {
  let shownTitles = 0;
  containers.forEach((container) => {
    if (container.closest('.multi-addresses-cell') && !container.classList.contains('hidden-title')) {
      shownTitles += 1;
    }
  });

  if (shownTitles > 0) {
    return true;
  }
}

const phoneButtonsContainers = q.all('.post-big-show-phone-container');
if (phoneButtonsContainers) {
  phoneButtonsContainers.forEach((container) => {
    const button = q('.post-big-show-phone', container);

    on(button, 'click', () => {
      button.classList.add('post-big-show-phone--hidden');

      const multipleAddresParent = container.closest('.multi-addresses-cell');
      if (multipleAddresParent) {
        if (q('.multi-addresses-icon', multipleAddresParent)) {
          q('.multi-addresses-icon', multipleAddresParent).classList.remove('hidden');
        }

        const titleIsShown = multipleTitleIsShown(phoneButtonsContainers);
        if (!titleIsShown) {
          container.classList.remove('hidden-title');
        }
      }

      requestAnimationFrame(() => emit(document, 'cascade-reflow', null, true));
    });
  });
}
